import { oz } from '@weft/utils';

export const NetSuiteInvoiceResponseSchema = oz.object({
  status: oz.object({
    id: oz.string(),
    refName: oz.string(),
  }),
  id: oz.string(),
  amountRemaining: oz.number(),
  externalId: oz.string(),
});

export type NetSuiteInvoiceResponse = oz.infer<typeof NetSuiteInvoiceResponseSchema>;